import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-background">
      {/* Left visual panel */}
      <div className="relative hidden lg:flex flex-col justify-between bg-[#090E17] text-white p-10 overflow-hidden">
        <div className="absolute inset-0 bg-grid-dark opacity-60" aria-hidden="true" />
        <div className="relative z-10">
          <Link to="/"><Logo variant="dark" /></Link>
        </div>
        <div className="relative z-10 max-w-md">
          <div className="overline mb-4" style={{ color: "rgba(255,255,255,0.55)" }}>Unified LMS</div>
          <h2 className="font-display font-black text-4xl xl:text-5xl tracking-tight leading-tight text-white">
            Multiple tracks. One secure doorway.
          </h2>
          <p className="mt-6 text-white/60 text-[14.5px] leading-relaxed">
            Sign in to pick up where you left off — or request access to a new niche-tech track
            and we'll route it to an admin for approval.
          </p>
          <div className="mt-10 grid grid-cols-2 gap-0 border border-white/15">
            {[
              { label: "Cloud", slug: "cloud-computing" },
              { label: "Data Science", slug: "data-science" },
              { label: "AI / ML", slug: "ai-ml" },
              { label: "Salesforce", slug: "salesforce" },
              { label: "ServiceNow", slug: "servicenow" },
              { label: "SAP", slug: "sap" },
            ].map((t, i) => (
              <div key={t.slug} className={`p-4 ${i % 2 === 0 ? "border-r" : ""} ${i < 4 ? "border-b" : ""} border-white/15`}>
                <div className="overline" style={{ color: "rgba(255,255,255,0.5)" }}>Track</div>
                <div className="font-display font-bold text-[14px] mt-1.5 text-white leading-tight">{t.label}</div>
              </div>
            ))}
          </div>
          <div className="mt-5 text-[11px] text-white/40 tracking-[0.2em] uppercase">+ AI Essentials of MH Govt &middot; and more on the way</div>
        </div>
        <div className="relative z-10 text-[11px] text-white/40 tracking-[0.22em] uppercase">
          Powered by Steadfast IT Consulting
        </div>
      </div>

      {/* Right form panel */}
      <div className="flex flex-col min-h-screen">
        <div className="lg:hidden border-b border-border p-6">
          <Link to="/"><Logo /></Link>
        </div>
        <div className="flex-1 flex items-center justify-center p-6 lg:p-12">
          <div className="w-full max-w-md">
            <div className="overline mb-3">{subtitle || "Steadfast Learning Hub"}</div>
            <h1 className="font-display font-black text-3xl lg:text-4xl tracking-tight leading-tight text-foreground mb-8">
              {title}
            </h1>
            {children}
          </div>
        </div>
        {footer ? (
          <div className="p-6 lg:p-12 border-t border-border text-[12.5px] text-muted-foreground">
            {footer}
          </div>
        ) : null}
      </div>
    </div>
  );
}
